import React, { useState } from "react";
import { TypeFaceText } from "../../../inputs/buttons.component";

const MetricSubheader = props => {
  const { title, required, tooltip, tooltipClass } = props;

  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div className="metric-submenu-subheader">
      {title}
      {required && <TypeFaceText />}
      {tooltip && (
        <div
          className="metricTargetHelptext permissionHelpText"
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
        ></div>
      )}
      {showTooltip && <div className={tooltipClass}>{tooltip}</div>}
    </div>
  );
};

export default MetricSubheader;
